import { RouteRecordRaw } from 'vue-router'

export default function getKnowledgeInsightsRouteConfig(): RouteRecordRaw[] {
  return [
    {
      path: '',
      name: 'knowledge-insights/overview',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/index.vue')
    },
    {
      path: 'common-knowledge',
      alias: 'common-knowledge',
      name: 'knowledge-insights/common-knowledge',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/CommonKnowledge.vue')
    },
    {
      path: 'expert-data',
      name: 'knowledge-insights/expert-data',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/ExpertData/index.vue')
    },
    {
      path: 'expert-knowledge',
      name: 'knowledge-insights/expert-knowledge',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/ExpertKnowledge.vue')
    },
    {
      path: 'knowledge-exchange',
      name: 'knowledge-insights/knowledge-exchange',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/KnowledgeExchange.vue')
    },
    {
      path: 'trending-topics',
      name: 'knowledge-insights/trending-topics',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/TrendingTopics.vue')
    },
    {
      path: 'topic-health',
      name: 'knowledge-insights/topic-health',
      component: () => import(/* webpackChunkName: "knowledge-insights" */ '@src/views/KnowledgeInsights/components/TopicHealth/index.vue')
    }
  ]
}
